import { render } from "./CoachRegestration.vue?vue&type=template&id=0f518c44"
import script from "./CoachRegestration.vue?vue&type=script&lang=js"
export * from "./CoachRegestration.vue?vue&type=script&lang=js"

import exportComponent from "/home/hiba/project03-vue.js-find-a-coach/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__